import {get, deleteRequest, post, put } from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper';

const serverUrl = getServerInfo('api');

export class PodsService {
    static getAll(token, queryParams = {}) {
        return get(`${serverUrl}pod`, token, queryParams)
    }

    static getById(id, token) {
        return get(`${serverUrl}pod/${id}`, token)
    }

    static bulkDelete(ids, token) {
        return deleteRequest(`${serverUrl}pod`, { ids }, true, token)
    }

    static delete(id, token) {
        return deleteRequest(`${serverUrl}pod/${id}`, null, false, token)
    }

    static create(data, token) {
        return post(`${serverUrl}pod`, data, true, token)
    }

    static update(id, data, token) {
        return put(`${serverUrl}pod/${id}`, data, true, token)
    }

    //Obtener maquinas virtuales asociadas a un pod por id (pod_id)
    static getPodxVmById(id, token) {
        return get(`${serverUrl}podxvm/${id}`, token)
    }

    static getFreepods(idlaboratory, token) {
        return get(`${serverUrl}freepods/${idlaboratory}`, token)
    }

}